import { Like } from "./theSource";

export interface CommunityPost {
    comments: Comment[];
    createdAt: string;
    owner: string;
    ownerDisplayName: string;
    content: string;
    containsMedia: boolean;
    updatedAt: string;
    year: number;
    previewUrl?: string;
    likes: Record<string, Like> | null;
    category: PostCategory;
}

export interface Comment {
    owner: string;
    ownerDisplayName: string;
    id: string;
    createdAt: string;
    updatedAt: string;
    content: string;
}

export enum PostCategory {
    COMMUNITY = 'community',
    MUSIC = 'music',
    VIDEO = 'video',
    PHOTO = 'photo',
}